// extracted by mini-css-extract-plugin
export default {"cls1":"PaperContainer-cls1__bb214f363760ab7e3f00","cls2":"PaperContainer-cls2__d3b1b61f715b459a2432 PaperContainer-cls1__bb214f363760ab7e3f00"};